// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/design-system/components/overlays/OverlayFooter.jsx

import React from "react";
import ActionGroup from "../actions/ActionGroup";

export default function OverlayFooter({
  actions = [],
  note = null,
  align = "end",
}) {
  if (!note && (!Array.isArray(actions) || actions.length === 0)) {
    return null;
  }

  return (
    <footer className="oasys-overlay-footer">
      {note ? (
        <div className="oasys-overlay-footer__note">{note}</div>
      ) : null}

      <ActionGroup
        actions={actions}
        align={align}
        className="oasys-overlay-footer__actions"
      />
    </footer>
  );
}
